<template>
  <footer class="footer">
    <div class="footer__copyright">
      <div>
        &copy; {{ getCurrentYear }} Flohmarktkönig
      </div>
    </div>
    <div class="footer__social-media">
      <div>
        <a href="https://www.facebook.com/Flohmikoenig" target="_blank">
          <facebook-icon size="25" />
        </a>
      </div>
      <div>
        <a href="https://www.instagram.com/flohmarktkoenig.ch/" target="_blank">
          <instagram-icon size="25" />
        </a>
      </div>
      <div>
        <a href="https://www.tiktok.com/@flohmarktkoenig.ch" target="_blank">
          <tik-tok-icon size="25" />
        </a>
      </div>
      <div>
        <a href="https://www.youtube.com/watch?v=dH4Gc4Cmemc" target="_blank">
          <you-tube-icon size="25" />
        </a>
      </div>
      <div v-if="!isIosWebView">
        <a href="https://play.google.com/store/apps/details?id=ch.flohmarktkoenig.app&amp;hl=de_CH&amp;gl=US" target="_blank">
          <google-play-icon size="25" />
        </a>
      </div>
      <div>
        <a href="https://apps.apple.com/iq/app/flohmarktk%C3%B6nig/id1618900972" target="_blank">
          <apple-icon size="25" />
        </a>
      </div>
    </div>    
    <div class="footer__nav">
      <div>
        <router-link :to="{name: 'Imprint'}">Impressum</router-link>
      </div>
      <div>
        <router-link :to="{name: 'DataProtection'}">Datenschutz</router-link>
      </div>
      <div>
        <router-link :to="{name: 'TermsAndCondition'}">AGB</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { 
  FacebookIcon, 
  InstagramIcon, 
  TikTokIcon,
  YouTubeIcon,
  GooglePlayIcon,
  AppleIcon
} from 'vue-simple-icons'
export default {
    components: {
      FacebookIcon,
      InstagramIcon, 
      TikTokIcon,
      YouTubeIcon,
      GooglePlayIcon,
      AppleIcon
    },
    name: "AppFooter",
    computed: {
      getCurrentYear() {
        return new Date().getFullYear()
      },
      userAgent() {
        return window.navigator.userAgent
      },
      isIosWebView() {
        return /iPhone.*AppleWebKit(?!.*Safari)/i.test(this.userAgent);
      }
    }
  }
</script>
